'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by zfc on 2016/10/20.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _reactRouter = require('react-router');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _AttentionSuccessModal = require('../AttentionSuccessModal/AttentionSuccessModal');

var _AttentionSuccessModal2 = _interopRequireDefault(_AttentionSuccessModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceOrderBuyComponent = (_dec = (0, _reduxForm.reduxForm)({
  form: 'serviceOrderBuyForm',
  fields: ['contactPerson', 'contactWay', 'company', 'requires']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServiceOrderBuyComponent, _Component);

  // serviceClientData: PropTypes.array

  function ServiceOrderBuyComponent() {
    (0, _classCallCheck3.default)(this, ServiceOrderBuyComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceOrderBuyComponent).call(this));

    _this.state = {
      isServicesModalOpened: false,
      isAgreeTipModalOpened: false,
      isAgreeServiceTip: false,
      closeHover: false
    };
    return _this;
  }

  (0, _createClass3.default)(ServiceOrderBuyComponent, [{
    key: 'onAgreeServiceBtnClick',
    value: function onAgreeServiceBtnClick() {
      var isAgreeServiceTip = this.state.isAgreeServiceTip;

      this.setState({
        isAgreeServiceTip: !isAgreeServiceTip
      });
    }
  }, {
    key: 'onServiceTipClick',
    value: function onServiceTipClick() {
      var isServicesModalOpened = this.state.isServicesModalOpened;

      this.setState({
        isServicesModalOpened: !isServicesModalOpened
      });
    }
  }, {
    key: 'onAgreeTipModelClose',
    value: function onAgreeTipModelClose() {
      this.setState({
        isAgreeTipModalOpened: false
      });
    }
  }, {
    key: 'onBuyBtnClick',
    value: function onBuyBtnClick() {
      var isAgreeServiceTip = this.state.isAgreeServiceTip;
      var handleSubmit = this.props.handleSubmit;

      if (!isAgreeServiceTip) {
        this.setState({
          isAgreeTipModalOpened: true
        });
      } else {
        handleSubmit();
      }
    }
  }, {
    key: 'contactPersonInit',
    value: function contactPersonInit(value) {
      var contactPerson = this.props.fields.contactPerson;

      contactPerson.onChange(value);
    }
  }, {
    key: 'contactWayInit',
    value: function contactWayInit(value) {
      var contactWay = this.props.fields.contactWay;

      contactWay.onChange(value);
    }
  }, {
    key: 'requireInit',
    value: function requireInit(value) {
      var requires = this.props.fields.requires;

      requires.onChange(value);
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var _props$fields = _props.fields;
      var contactPerson = _props$fields.contactPerson;
      var contactWay = _props$fields.contactWay;
      var company = _props$fields.company;
      var requires = _props$fields.requires;
      var serviceBuyData = _props.serviceBuyData;
      // handleSubmit,

      var _state = this.state;
      var isServicesModalOpened = _state.isServicesModalOpened;
      var isAgreeTipModalOpened = _state.isAgreeTipModalOpened;
      var isAgreeServiceTip = _state.isAgreeServiceTip;
      var closeHover = _state.closeHover;
      // console.log(isAgreeServiceTip);

      var styles = require('./ServiceOrderBuyComponent.scss');
      var allCustomStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem 0px',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          height: '37rem',
          minWidth: '20rem',
          width: '65rem',
          maxWidth: '80rem'
        }
      };
      /* const allCustomStyle2 = {
         content: {
           background: '#ffffff',
           overflow: 'hidden',
           outline: 'none',
           zIndex: 9999,
           border: '0',
           borderRadius: '30px',
           boxShadow: '3px 2px 20px',
           bottom: 'auto',
           minHeight: '10rem',
           left: '50%',
           padding: '2rem 0px',
           position: 'fixed',
           right: 'auto',
           top: '50%',
           transform: 'translate(-50%,-50%)',
           minWidth: '20rem',
           width: '40rem',
           maxWidth: '60rem'
         }
       };*/
      return _react2.default.createElement(
        'div',
        { className: styles.serviceBuyComponent },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          _react2.default.createElement(
            'div',
            { className: styles.titleContent },
            '购买服务'
          )
        ),
        serviceBuyData instanceof Array && serviceBuyData.length > 0 ? _react2.default.createElement(
          'div',
          { className: styles.box },
          _react2.default.createElement('img', { className: styles.shopImg, src: serviceBuyData[0].img }),
          _react2.default.createElement(
            'div',
            { className: styles.serviceContent },
            _react2.default.createElement(
              'div',
              { className: styles.tit },
              serviceBuyData[0].name || ''
            ),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              _react2.default.createElement(
                'div',
                { className: styles.textTil },
                '服务商: '
              ),
              serviceBuyData[0].shop || ''
            ),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              _react2.default.createElement(
                'div',
                { className: styles.textTil },
                '服务价格: '
              ),
              _react2.default.createElement(
                'span',
                { style: { color: '#ff0000' } },
                '¥'
              ),
              _react2.default.createElement(
                'span',
                {
                  style: { color: '#ff0000' } },
                serviceBuyData[0].price || ''
              ),
              _react2.default.createElement(
                'div',
                { className: styles.ts },
                '(实际成交价格以双方最终确定价格为准)'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              _react2.default.createElement(
                'div',
                { className: styles.textTil },
                '服务内容: '
              ),
              _react2.default.createElement(
                'div',
                { className: styles.ts2 },
                serviceBuyData[0].content || ''
              )
            )
          )
        ) : '',
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.lianxi },
          '留下您的联系方式，服务商可以更快的与您沟通'
        ),
        _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: '90%', float: 'left' }, afterInit: this.contactPersonInit.bind(this),
          label: '企业信息：', inputType: 'text', disabled: 1 !== 0,
          formProps: company }),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/personalcenter/personalinfo/companyinfo',
            style: { fontSize: 14, fontFamily: 'fontNameRegular', textDecoration: 'underline', marginTop: 20, height: 35, float: 'left', lineHeight: '35px', color: '#ff0000' } },
          '修改'
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: '90%' }, afterInit: this.contactPersonInit.bind(this), label: '联系人：',
          inputType: 'text',
          formProps: contactPerson }),
        _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: '90%' }, afterInit: this.contactWayInit.bind(this), label: '联系方式：',
          inputType: 'text',
          formProps: contactWay }),
        _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: '90%' }, afterInit: this.requireInit.bind(this), inputType: 'textarea',
          inputPlaceholder: '请告诉服务商您的具体要求......',
          formProps: requires }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.tip, style: { float: 'right', marginRight: 500 } },
          _react2.default.createElement('img', {
            style: { marginRight: 3 },
            onClick: function onClick() {
              return _this2.onAgreeServiceBtnClick();
            },
            src: isAgreeServiceTip ? 'http://tupian.goeasy.cn:9999/yipinwang/per_center/radio_hover.png' : 'http://tupian.goeasy.cn:9999/yipinwang/per_center/radio.png' }),
          '我已同意并阅读',
          _react2.default.createElement(
            'span',
            {
              onClick: function onClick() {
                return _this2.onServiceTipClick();
              }, style: { color: '#ff0000', cursor: 'pointer' } },
            '《艺品网服务条款》'
          )
        ),
        _react2.default.createElement(
          _reactModal2.default,
          { style: allCustomStyle, isOpen: isServicesModalOpened },
          _react2.default.createElement(
            'div',
            { className: styles.modalTitle },
            _react2.default.createElement('img', { className: closeHover ? styles.xuzhuan : styles.xuzhuan_a, onMouseOver: this.closeImgMouseOver.bind(this),
              onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: function onClick() {
                return _this2.onServiceTipClick();
              },
              src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
              width: '100%' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalTiaokuan },
            _react2.default.createElement(
              'h1',
              null,
              '艺品网服务协议'
            ),
            '  本协议由您与艺品网共同缔结，具有合同效力。本协议中艺品网在协议中称为“中艺艺品”，协议签约的另一方成为会员或用户。   中艺艺品（www.craftschina.cn）是为商家与会员搭建的艺品鉴赏、艺品定制、艺品交易、艺品服务的在线服务平台。双方各自利用中国艺 品平台完成展示、推广、交流、交易等服务，艺品网不参与网络交易。为获得艺品网提供基于互联网的相关服务，服务使用人(以下称“用户”) 必须同意本协议的全部条款并按照页面上的提示完成注册程序。如果用户在注册程序过程中点击“我同意”按钮即表示用户完全接受本协议项下的全部条款。 本协议内容包括协议正文及所有艺品网网已经发布的各类规则。所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。',
            _react2.default.createElement('br', null),
            '  若您已经注册为本网站会员，即表示您已充分阅读、理解并同意自己与本网站订立本协议，且您自愿受本协议的条款约束。本网站有权随时修改本协议及艺品网规则，并在本网站上予以公告。本协议或各类规则如有任何修改，艺品网将在本网站上刊载公告，通知用户。经修订的条款一经在艺品网公布后，立即自动生效。   如您不同意相关修改，必须停止使用本网站。如您登录或继续使用“服务”，视为您接受经修订的协议和规则。除另行明确声明外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。',
            _react2.default.createElement('br', null),
            '  请您务必在注册之前认真阅读全部服务协议内容，如有任何疑问，可向艺品网咨询。',
            _react2.default.createElement('br', null),
            '  无论您事实上是否在注册之前认真阅读了本服务协议，只要您点击协议正本下方的“我同意”按钮并按照注册程序成功注册为用户，您的行为仍然表示其同意并签署了本服务协议。',
            _react2.default.createElement('br', null),
            '  本协议不涉及您与其它艺品网用户之间因网上交易而产生的法律关系及法律纠纷。',
            _react2.default.createElement('br', null),
            '  1.用户注册',
            _react2.default.createElement('br', null),
            '    1.1用户注册是指用户登陆中艺艺品，并按要求填写相关信息并确认同意履行相关用户协议的过程。',
            _react2.default.createElement('br', null),
            '    1.2符合下列条件之一的自然人或法人才能申请成为本网站会员，（商家会员还需签订合作协议提交相关材料、经网站管理人员审核通过）可以使用本网站的服务。',
            _react2.default.createElement('br', null),
            '      1.2.1根据中国法律年满18周岁，具备完全民事行为能力的自然人或根据国外法律具有完全民事行为能力的自然人。',
            _react2.default.createElement('br', null),
            '      1.2.2无民事行为能力人、限制民事行为能力人应经过其监护人同意。',
            _react2.default.createElement('br', null),
            '      1.2.3根据中国或外国法律、法规、行政规章成立并合法存在的机关、企事业单位、社团组织和其他组织。未经批准设立的组织不能注册为中艺艺品用户。',
            _react2.default.createElement('br', null),
            '    1.3不当注册为中艺艺品用户或超过其民事权利或行为能力范围从事交易的，其与中艺艺品之间的服务协议自始无效，一经发现，中艺艺品有权立即注销该用户，并追究其使用中艺艺品“服务”的一切法律责任。',
            _react2.default.createElement('br', null),
            '    1.4用户完成注册申请手续后，获得中艺艺品帐号。用户应提供明确的联系地址和联系电话，并提供真实姓名或名称，并不断更新注册资料。所有原始键入的资料将引用为注册资料。对于因注册信息不真实而引起的问题，以及该问题发生所带来的后果，中艺艺品不负任何责任。用户应当对以其用户帐号进行的所有活动和事件负法律责任。',
            _react2.default.createElement('br', null),
            '  2.用户的权利义务',
            _react2.default.createElement('br', null),
            '    2.1用户有权根据本协议及本网站发布的相关规则，利用本网站发布信息、查询、评论等。参加本网站的有关活动及有权享受本网站提供的其他有关资讯及信息服务。',
            _react2.default.createElement('br', null),
            '    2.2用户须自行负责自己的会员账号和密码，且须对在会员账号密码下发生的所有活动（包括但不限于发布信息、评论、网上点击同意各类协议、规则等）承担责任。用户有权根据需要更改登录密码。',
            _react2.default.createElement('br', null),
            '    2.3用户应当向本网站提供真实准确的注册信息，包括但不限于真实姓名、身份证号、联系电话、地址、邮政编码等，保证本网站可以通过上述联系方式与自己进行联系。（商家会员另附合作协议）同时，用户也应当在相关资料实际变更时及时更新有关注册资料。',
            _react2.default.createElement('br', null),
            '      2.3.1禁止用户将其帐号、密码转让或出借予他人使用，如用户发现其帐号遭他人非法使用，应立即通知中艺艺品。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，中艺艺品不承担任何责任。',
            _react2.default.createElement('br', null),
            '      2.3.2用户注册会员名时请勿使用敏感词汇（包括但不限于：不雅词汇、涉及政治、法律等），以及含有中艺艺品、版主、管理员、等词汇，中艺艺品有权删除此类账户，无需通知第三方。',
            _react2.default.createElement('br', null),
            '    2.4中艺艺品账号的所有权归中艺艺品所有，用户不得以任何形式擅自转让或授权他人使用自己在本网站的会员帐号。',
            _react2.default.createElement('br', null),
            '    2.5用户有义务确保在本网站上发布的信息真实、准确，无误导性。',
            _react2.default.createElement('br', null),
            '    2.6用户在本网站网上发布，不得发布国家法律、法规、行政规章规定禁止的信息、侵犯他人知识产权或其他合法权益的信息、违背社会公共利益或公共道德的信息。',
            _react2.default.createElement('br', null),
            '    2.7用户在本网站交易中应当遵守诚实信用原则，不得以发布侵权信息、虚假信息等不正当竞争方式扰乱网上秩序，不得从事与网上无关的不当行为，不得在交易平台上发布任何违法信息。',
            _react2.default.createElement('br', null),
            '    2.8用户不应采取不正当手段（包括但不限于虚假交易、互换好评等方式）提高自身或他人信用度，或采用不正当手段恶意评价其他用户，降低其他用户信用度。',
            _react2.default.createElement('br', null),
            '    2.9用户承诺使用中艺艺品，须遵守中华人民共和国相关法律法规，包括但不限于《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《中华人民共和国著作权法》及《信息网络传播权保护条例》等有关计算机互联网和知识产权的相关法律法规及规章规定等。如有违反导致任何法律后果的发生，用户将以自己的名义独立承担相应的法律责任。',
            _react2.default.createElement('br', null),
            '    2.10用户在本网站网上交易过程中如与其他用户因交易产生纠纷，可以请求本网站从中予以协调处理。用户如发现其他用户有违法或违反本协议的行为，可以向本网站举报。',
            _react2.default.createElement('br', null),
            '    2.11用户应当自行承担因交易产生或取得的相关费用，并依法纳税。',
            _react2.default.createElement('br', null),
            '    2.12未经本网站书面允许，用户不得使用本网站的任何资料以及在交易平台上所展示的任何信息（包括但不限于以复制、修改、翻译等形式制作衍生作品、分发或公开展示）。',
            _react2.default.createElement('br', null),
            '    2.13用户不得使用以下方式登录网站或破坏网站所提供的服务。',
            _react2.default.createElement('br', null),
            '      2.13.1以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它自动方式访问或登录本网站。',
            _react2.default.createElement('br', null),
            '      2.13.2通过任何方式对本公司内部结构造成或可能造成不合理或不合比例的重大负荷的行为。',
            _react2.default.createElement('br', null),
            '      2.13.3通过任何方式干扰或试图干扰网站的正常工作或网站上进行的任何活动。',
            _react2.default.createElement('br', null),
            '    2.14用户有权在同意本网站相关规则的前提下享受服务保障。',
            _react2.default.createElement('br', null),
            '    2.15用户同意接收来自本网站的信息，包括但不限于活动信息、交易信息、促销信息等。',
            _react2.default.createElement('br', null),
            '    2.16用户不得为任何非法目的而使用网络服务系统，遵守所有与网络服务有关的网络协议、规定和程序。',
            _react2.default.createElement('br', null),
            '    2.17用户不得利用中艺艺品服务进行任何可能对互联网的正常运转造成不利影响的行为。',
            _react2.default.createElement('br', null),
            '    2.18用户不得利用中艺艺品服务传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料。',
            _react2.default.createElement('br', null),
            '    2.19用户不得利用买中艺艺品服务进行任何不利于中艺艺品或损害中艺艺品利益的行为。',
            _react2.default.createElement('br', null),
            '    2.20用户如发现任何非法使用会员帐号或帐号出现安全漏洞的情况，应立即通告中艺艺品。',
            _react2.default.createElement('br', null),
            '  3. 中艺艺品的权利义务',
            _react2.default.createElement('br', null),
            '    3.1中艺艺品为装饰材料、软装配饰、建筑设备等提供一个交流、推广、交易的平台。艺品网络服务的具体内容由中艺艺品根据实际情况提供，例如作品搜索、作品上传等。',
            _react2.default.createElement('br', null),
            '    3.2中艺艺品将在现有技术水平的基础上保证平台的正常运行，避免网站服务中断等情形出现，保障用户的服务活动顺利进行。',
            _react2.default.createElement('br', null),
            '    3.3对用户使用中艺艺品上交易平台中所遇到与中艺艺品上注册或与交易有关的问题或情况，应及时回复。',
            _react2.default.createElement('br', null),
            '    3.4艺品网设置的各种积分制度是为了调动网站用户的参与积极性，中艺艺品有权随时修改积分制度，调整用户的相关积分属性，未经中艺艺品许可，会员禁止以任何形式出售积分。',
            _react2.default.createElement('br', null),
            '    3.5中艺艺品有权在艺品网站的任意位置、任意时间投放各种广告，但广告内容不影响网站注册用户正常使用网站各项功能。',
            _react2.default.createElement('br', null),
            '    3.6用户在中艺艺品上交易过程中如与其它用户因交易产生纠纷，请求中艺艺品从中予以调处，艺品网审核后，中艺艺品有权通过中艺艺品站内短信、会员QQ、电子邮件等联系方式向纠纷双方了解情况，并将所了解的情况互相通知对方；用户通过司法或行政等手段解决纠纷的，中艺艺品将依照法定程序提供相关资料。',
            _react2.default.createElement('br', null),
            '    3.7对于用户在艺品网上交易平台上的不当行为或其它任何中艺艺品认为应当终止服务的情况，中艺艺品有权随时作出删除相关信息、终止服务提供等处理，而无须征得用户的同意。',
            _react2.default.createElement('br', null),
            '    3.8因网上交易平台的特殊性，中艺艺品没有义务对所有用户的注册数据、所有的交易行为以及与交易有关的其它事项进行事先审查。但如存在下列情况， 中艺艺品有权无需征得会员的同意，可根据不同情况选择保留或删除相关信息、限制用户的活动、向用户核实有关资料、发出警告通知、暂时中止、无限期中止及拒绝向该用户提供服务。',
            _react2.default.createElement('br', null),
            '      3.8.1违反本服务协议及纳入本协议的其他规则的相关规定的。',
            _react2.default.createElement('br', null),
            '      3.8.2用户或其它第三方通知艺品网，认为某个具体用户或具体交易事项可能存在重大问题。',
            _react2.default.createElement('br', null),
            '      3.8.3用户或其它第三方向艺品网告知交易平台上有违法或不当行为的，并提供相关证据，而中艺艺品无法联系到该用户进行核实，或者中艺艺品以普通非专业交易者的知识水平标准对相关内容进行判别，可以明显认为这些内容或行为具有违法或不当性质的。',
            _react2.default.createElement('br', null),
            '    3.9经国家生效法律文书或行政处罚决定确认用户存在违法行为，或者中艺艺品有足够事实依据可以认定用户存在违法或违反服务协议行为以及在本网站交易平台上的其他不当行为，中艺艺品有权在中艺艺品交易平台及所在网站上以网络发布形式公布用户的违法行为；并有权随时作出删除相关信息、终止服务提供等处理。',
            _react2.default.createElement('br', null),
            '    3.10对于用户在中艺艺品交易平台发布的下列各类信息，中艺艺品有权在不通知用户的前提下进行删除或采取其它限制性措施，包括但不限于：以规避费用为目的的信息；以炒作信用为目的的信息；中艺艺品有理由相信存在欺诈等恶意或虚假内容的信息；中艺艺品有理由相信与网上交易无关或不是以交易为目的的信息；中艺艺品有理由相信存在恶意竞价或其它试图扰乱正常交易秩序因素的信息；中艺艺品有理由相信该信息违反公共利益或可能严重损害中艺艺品和其它用户合法利益的；中艺艺品有理由相信侵犯他人知识产权的信息等。',
            _react2.default.createElement('br', null),
            '    3.11中艺艺品依据本协议及相关规则，可以冻结、使用、退款、处置会员缴存并冻结在本网站账户内的资金。',
            _react2.default.createElement('br', null),
            '    3.12当第三方认为用户上传或者发表于中艺艺品的信息侵犯其权利，并根据相关法律规定向中艺艺品发送停止侵权通知时，用户同意中艺艺品可以根据第三人的证据自行判断、决定是否删除涉嫌侵权的的信息。删除涉嫌侵权信息之后，除非收到用户符合相关法律规定的书面说明，中艺艺品将不会自动恢复上述删除的信息。',
            _react2.default.createElement('br', null),
            '    3.13中艺艺品有权建立保障服务制度，保障用户的合法权益。',
            _react2.default.createElement('br', null),
            '  4.服务的变更、中断或终止',
            _react2.default.createElement('br', null),
            '    4.1鉴于网络服务的特殊性，用户同意中艺艺品可自行全权决定，在发出通知或不发出通知的情况下，随时变更、中断或终止部分或全部的网络服务。服务终止后，中艺艺品没有义务为用户保留原账户或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方。此外，用户同意，中艺艺品不就终止用户接入“服务”而对用户或任何第三者承担任何责任。',
            _react2.default.createElement('br', null),
            '      4.1.1如变更、中断或终止的网络服务属于免费网络服务，中艺艺品无需通知用户，也无需对任何用户或任何第三方承担任何责任，当中艺艺品变更、中断或终止全部的网络服务时，中艺艺品无须为会员在中艺艺品获得的各种积分提供赔偿、退款服务。',
            _react2.default.createElement('br', null),
            '      4.1.2如变更、中断或终止的网络服务涉及收费网络服务，中艺艺品应当按照该用户实际使用相应收费网络服务的情况扣除相应服务费之后将剩余的服务费退还给该用户。',
            _react2.default.createElement('br', null),
            '    4.2中艺艺品需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，中艺艺品无需为此承担任何责任，但中艺艺品应尽可能事先进行通告。',
            _react2.default.createElement('br', null),
            '    4.3用户同意中艺艺品基于其自行之考虑，因任何理由，包含但不限于长时间未使用，或中艺艺品认为用户已经违反本服务协议的文字及精神，无需进行事先通知即可中断或终止，终止您的密码、帐号或本服务之使用。用户承认并同意，中艺艺品可立即关闭或删除用户的帐号及帐号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，用户同意若本服务之使用被中断或终止或用户的帐号及相关信息和文件被关闭或删除，中艺艺品对用户或任何第三人均不承担任何责任。',
            _react2.default.createElement('br', null),
            '    4.4如用户注册的免费网络服务的帐号在任何连续360日内未实际使用，则中艺艺品有权删除该帐号并停止为该用户提供相关的网络服务。',
            _react2.default.createElement('br', null),
            '    4.5若用户向本网站提出注销中艺艺品注册会员身份，需经中艺艺品审核同意，注销该注册会员，会员即解除与中艺艺品的协议关系，但中艺艺品仍保留下列权利。',
            _react2.default.createElement('br', null),
            '      4.5.1中艺艺品有权在法律、法规、行政规章规定的时间内保留该会员的资料,包括但不限于会员资料、交易记录等。',
            _react2.default.createElement('br', null),
            '      4.5.2若会员注销前在中艺艺品交易平台上存在违法行为或违反本协议的行为，中艺艺品仍可行使本协议及相关规则所规定的权利，追究该会员的法律责任。',
            _react2.default.createElement('br', null),
            '  4.6用户存在下列情况，中艺艺品可以通过注销会员的方式终止服务。',
            _react2.default.createElement('br', null),
            '    4.6.1在用户违反本协议及相关规则规定时，中艺艺品有权终止向用户提供服务。中艺艺品将在终止服务时通知会员。但该用户在被中艺艺品终止提供服务后，再一次直接或间接或以他人名义注册为中艺艺品用户的，中艺艺品有权再次单方面终止为该用户提供服务。',
            _react2.default.createElement('br', null),
            '    4.6.2中艺艺品发现用户注册资料中主要内容是虚假的，中艺艺品有权随时终止为该用户提供服务。',
            _react2.default.createElement('br', null),
            '    4.6.3本协议终止或修改后，用户未确认新的协议的。',
            _react2.default.createElement('br', null),
            '    4.6.4其它中艺艺品认为需终止服务的情况。',
            _react2.default.createElement('br', null),
            '  5.隐私保护',
            _react2.default.createElement('br', null),
            '    5.1信息使用',
            _react2.default.createElement('br', null),
            '      5.1.1保护用户隐私是中艺艺品的一项基本原则，中艺艺品不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在中艺艺品的非公开内容。',
            _react2.default.createElement('br', null),
            '      5.1.2中艺艺品不允许任何第三方以任何手段收集、编辑、出售或者无偿传播会员的信息。任何用户有本条所禁止的行为，一经发现，中艺艺品有权立即终止与该用户的服务协议，查封其账号。',
            _react2.default.createElement('br', null),
            '      5.1.3在不透露单个用户隐私资料的前提下，中艺艺品有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。',
            _react2.default.createElement('br', null),
            '      5.1.4为服务用户的目的，中艺艺品可能通过使用用户的个人信息，向用户提供服务，包括但不限于向用户发出产品和服务信息，或者与中艺艺品合作伙伴共享信息以便他们向用户发送有关其产品和服务的信息。',
            _react2.default.createElement('br', null),
            '      5.1.5为验证用户信息的真实性，中艺艺品有权通过第三方核查用户的隐私材料，无需另外向用户支付信息使用费。因用户自身原因导致多次重复验证的，中艺艺品有权依照网站规定向用户收取信息验证费。',
            _react2.default.createElement('br', null),
            '    5.2信息披露：用户的信息将在下述情况下部分或全部被披露。',
            _react2.default.createElement('br', null),
            '      5.2.1事先获得用户的明确授权。',
            _react2.default.createElement('br', null),
            '      5.2.2若用户是合法的知识产权权利人并提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。',
            _react2.default.createElement('br', null),
            '      5.2.3用户出现违反中国法律法规、规章、制度或者中艺艺品规定的情况，需要向第三方披露。',
            _react2.default.createElement('br', null),
            '      5.2.4根据法律的有关规定，或者行政、司法机关的要求，向第三方或者行政、司法机关披露。',
            _react2.default.createElement('br', null),
            '      5.2.5为提供用户所要求的产品和服务，而必须和第三方分享用户的个人信息。',
            _react2.default.createElement('br', null),
            '      5.2.6中艺艺品可能会与第三方合作向用户提供相关的网络服务，在该第三方同意承担与中艺艺品同等的用户隐私权保护责任的情况下，用户同意中艺艺品向该第三方披露其注册信息及在中艺艺品的其他资料等。',
            _react2.default.createElement('br', null),
            '      5.2.7中艺艺品根据法律或者本网站规定认为合适的披露。',
            _react2.default.createElement('br', null),
            '    5.3信息安全',
            _react2.default.createElement('br', null),
            '      5.3.1在使用本网站服务进行网上交易时，请用户妥善保护自己的信息，仅在必要的情形下向他人提供。',
            _react2.default.createElement('br', null),
            '      5.3.2如果用户发现自己的信息泄密，尤其是注册账户或支付账户及密码发生泄露，请用户立即联络中艺艺品客服，以便我们采取相应措施。',
            _react2.default.createElement('br', null),
            '  6.免责声明',
            _react2.default.createElement('br', null),
            '    6.1中艺艺品只是为用户提供一个沟通、展示服务平台，对于用户所发布的信息的合法性、真实性及其品质，以及用户履行交易的能力等，本网站一律不负任何担保责任。用户明确同意其使用艺品网络服务所存在的风险将完全由其自己承担；因其使用艺品网络服务而产生的一切后果也由其自己承担，中艺艺品对用户不承担任何责任。',
            _react2.default.createElement('br', null),
            '    6.2中艺艺品不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。',
            _react2.default.createElement('br', null),
            '    6.3中艺艺品不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该外部链接指向的不由中艺艺品实际控制的任何网页上的内容，中艺艺品不承担任何责任。',
            _react2.default.createElement('br', null),
            '    6.4对于因不可抗力或中艺艺品不能控制的原因造成的网络服务中断或其它缺陷，中艺艺品不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。',
            _react2.default.createElement('br', null),
            '    6.5用户同意，对于中艺艺品向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，中艺艺品无需承担任何责任。',
            _react2.default.createElement('br', null),
            '      6.5.1中艺艺品向用户免费提供的各项网络服务。',
            _react2.default.createElement('br', null),
            '      6.5.2中艺艺品向用户赠送的任何产品或者服务。',
            _react2.default.createElement('br', null),
            '      6.5.3中艺艺品向收费网络服务用户附赠的各种产品或者服务。',
            _react2.default.createElement('br', null),
            '  7.知识产权',
            _react2.default.createElement('br', null),
            '    7.1中艺艺品及中艺艺品所使用的任何相关软件、程序、内容，包括但不限于作品、图片、档案、资料、网站构架、网站版面的安排、网页设计、经由中艺艺品或广告商向用户呈现的广告或资讯，均由中艺艺品或其它权利人依法享有相应的知识产权及物权，包括但不限于著作权、商标权、专利权或其它专属权利等，受到相关法律的保护。未经中艺艺品或权利人明示授权，用户不得以修改、出租、出借、出售、散布等方式使用中艺艺品及中艺艺品所使用的上述任何资料和资源，或根据上述资料和资源制作成任何种类产品。',
            _react2.default.createElement('br', null),
            '    7.2用户不得经由非本网站所提供的界面使用本网站。',
            _react2.default.createElement('br', null),
            '  8.通知送达',
            _react2.default.createElement('br', null),
            '    8.1本协议项下，中艺艺品对于用户所有的通知均可通过网页公告、中艺艺品站内短信、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。',
            _react2.default.createElement('br', null),
            '  9.不可抗力',
            _react2.default.createElement('br', null),
            '    9.1因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，双方均不承担责任。本协议所称之不可抗力是指双方不能合理控制、不可预见或及时预见亦无法避免的事件（包括但不限于政府行为、自然灾害、核可攻击、病毒感染、第三方服务故障、网络平台及平台软件服务器崩溃、电信部门技术管制、战争或任何其他类似事件），该事件妨碍、影响或延误乙方根据本协议履行其全部或部分义务。',
            _react2.default.createElement('br', null),
            '  10.保密',
            _react2.default.createElement('br', null),
            '     10.1用户对讨论、签订、执行本协议中所获悉的属于对方的、且无法自公开渠道获得的文件及资料（包括但不限于商业秘密、公司计划、运营活动、财务信息、技术信息、经营信息及其他商业秘密）予以保密。未经该资料和文件的原提供方同意，另一方不得向第三方泄露该商业秘密的全部或者部分内容。但法律、法规、行政规章另有规定或者双方另有约定的除外。',
            _react2.default.createElement('br', null),
            '  11.争议解决',
            _react2.default.createElement('br', null),
            '    11.1本协议及其规则的有效性、履行及争议解决等所有事宜，均适用中华人民共和国法律法规及相关规定。',
            _react2.default.createElement('br', null),
            '    11.2就本协议及协议所附规则的内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，均应向相关法律机构提起诉讼。',
            _react2.default.createElement('br', null),
            '    11.3中艺艺品有权受理并调处您与其他用户因交易服务产生的争议，同时有权单方面以非专业交易者的知识水平标准独立判断其他会员对您的投诉及索偿是否成立。若本网站判断索偿成立，则本网站有权使用您已被托管的任务赏金、交纳的交易保障金、账户内未提现的金额进行相应偿付。本网站没有使用自用资金进行偿付的义务，但 若进行了该等支付，您应及时赔偿本网站的全部损失，否则本网站有权通过前述方式抵减相应资金或权益，如仍无法弥补损失，则本网站保留继续追偿的权利。因本网站非司法机关，您完全理解并承认，本网站对证据的鉴别能力及对纠纷的处理能力有限，受理交易争议完全是基于您之委托，不保证争议处理结果符合您的期望， 本网站有权决定是否参与争议的调处。',
            _react2.default.createElement('br', null),
            '  12.附则',
            _react2.default.createElement('br', null),
            '    12.1在本协议中所使用的下列词语，除非另有定义，应具有以下含义',
            _react2.default.createElement('br', null),
            '      12.1.1 "本网站"在无特别说明的情况下，均指"中艺艺品"（www.craftschina.cn）。',
            _react2.default.createElement('br', null),
            '      12.1.2“用户”： 指具有完全民事行为能力的中艺艺品各项服务的使用者。',
            _react2.default.createElement('br', null),
            '      12.1.3 “会员”： 指与中艺艺品签订《中艺艺品服务协议》并完成注册流程的用户。',
            _react2.default.createElement('br', null)
          )
        ),
        _react2.default.createElement(_AttentionSuccessModal2.default, { isOpened: isAgreeTipModalOpened,
          loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/zhuce_sucess_1.png") no-repeat' },
          closeModalFunc: this.onAgreeTipModelClose.bind(this),
          text: '是否同意服务条款未选中' }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'a',
          { className: styles.btn, onClick: function onClick() {
              return _this2.onBuyBtnClick();
            } },
          '购买服务'
        )
      );
    }
  }]);
  return ServiceOrderBuyComponent;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,

  serviceBuyData: _react.PropTypes.array }, _temp)) || _class);
exports.default = ServiceOrderBuyComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceOrderBuyComponent/ServiceOrderBuyComponent.js
 ** module id = 1419
 ** module chunks = 0
 **/